export default {
  expiresSoon: 'Prístup k "{appName}" bude deaktivovaný po {expiryDate}.',
  pinApp: 'Pripnúť aplikáciu na navigačný panel',
  unpinApp: 'Odopnúť aplikáciu z navigačného panela',
};
